import { TweenMax, Power2 } from "gsap/TweenMax";
import * as ScrollMagic from 'scrollmagic';
import 'animation.gsap'

//import 'debug.addIndicators'

export default {
  init() {

    $('.expanding-video').each( (index, playerSection) => {

      if( $(window).width() <= 768 ) {
        return;
      }

      let playerTrigger = $(playerSection).prev('.expanding-video__trigger')[0];
      let scaleValue = this.fillWindow( $(playerSection).find('.expanding-video__wrapper') );
      let controller = new ScrollMagic.Controller();
      let tween = TweenMax.to(playerSection, 0.5, {
        scale: scaleValue,
        transformOrigin:'50% 0%',
        ease:Power2.easeIn,
        rotation: 0.01,
        force3D: true,
        refreshInterval: 5000,
      });

      new ScrollMagic.Scene({
        triggerElement: playerTrigger,
        duration: '80%',
        triggerHook: 'onEnter',
        offset: '0',
      })
      .setTween(tween)
      .addTo(controller);

      $(window).on('resize', () => {
        this.reflow(playerSection);
      }).trigger('resize');

    });

    $('.expanding-video').on('click', (e) => {
      $(e.currentTarget).addClass('expanding-video--play');
    });

    if( $('.video').length ) {

      window.runAgain = true;
      $('body').on('mousewheel DOMMouseScroll', function() {
        if(! window.runAgain ) {
          return
        }
        setTimeout(function(){
          $('.expanding-video').toggleClass("cursor");
          window.runAgain =  true;
        }, 100);

        window.runAgain = false;
      });
    }

  },
  fillWindow($el) {

    var currentWidth = $el.width();

    var availableWidth = (window.innerWidth - 100);

    return availableWidth / currentWidth;

  },
  reflow(playerSection) {
    // adjust player height based on full 'scaled' height.
    let scaleValue = this.fillWindow( $(playerSection).find('.expanding-video__wrapper') );

    $(playerSection).css('height', $('.expanding-video__wrapper').outerHeight() * scaleValue);
  },
}



// WEBPACK FOOTER //
// ./scripts/blocks/expanding-video.js